import { setLoanData } from 'actions'
import { LayoutLoading } from 'components/LayoutLoading'
import { useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateLoanFields } from 'services'
import { Button } from 'stories/components'
import { removeDuplicates, showDistances } from 'utils'
import { RenderInput } from 'utils/RenderInput'

const PropertyLogistics = () => {
  const [isLoading, setLoading] = useState(false)

  const { loan } = useSelector((state: any) => ({
    loan: state.loan,
  }))

  const dispatch = useDispatch()

  const addressOptions = useMemo(() => {
    return removeDuplicates([loan.subjectPropertyAddress, ...loan.additionalPropertyAddress].filter((v) => !!v))
  }, [loan.additionalPropertyAddress])

  const onUpdateAdditionalPropertyAddress = async (data: string[]) => {
    setLoading(true)
    await dispatch(setLoanData({ key: 'additionalPropertyAddress', data }))
    await updateLoanFields({ additionalPropertyAddress: data })
    setLoading(false)
  }

  const onShowDistance = () => {
    showDistances('Distances', { addresses: addressOptions })
  }

  return (
    <div className={`PropertyLogistics-container`}>
      <div className="max-w-screen-2xl m-auto">
        <div className={`relative bg-white`}>
          <LayoutLoading show={isLoading} />
          <div className="ml-2 text-2xl font-variation-settings-600 my-2">
            <span>Property Logistics</span>
          </div>

          <RenderInput
            Key=""
            input={{ inputType: 'section', title: 'Additional Property Addresses' }}
            onChange={() => {}}
          />
          <div className="overflow-auto mb-6 mt-4">
            <RenderInput
              Key="additionalPropertyAddress"
              input={{
                title: 'Additional Property Address',
                inputType: 'AutoComplete',
                autoCompleteType: 'map',
                error: '',
                length: 1,
                value: loan.additionalPropertyAddress,
              }}
              onChange={(_key: string, value: string[]) => onUpdateAdditionalPropertyAddress(value)}
            />
          </div>

          {addressOptions.length >= 2 && (
            <div className="mt-6">
              <Button onClick={onShowDistance} className="px-9">
                Show Distance
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default PropertyLogistics
